var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.showAdminMenu)?_c('side-bar'):_vm._e(),_c('div',{staticClass:"pt-4"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }